<template>
  <div style="text-align: left">
    <div style="margin-bottom: 10px">
      <el-dropdown @command="handleCommand" v-role="['1', '2']">
        <el-button type="primary" size="small">
          在线报名<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="addPlayer">单双人组</el-dropdown-item>
          <el-dropdown-item command="addgroup">6-12人组</el-dropdown-item>
          <el-dropdown-item command="addteam">团体舞</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button type="primary" v-role="['1', '2']" size="small" class="delete" @click="importBatch">
        <i class="el-icon-circle-plus-outline"></i>导入报名表
      </el-button>

      <el-button type="danger" size="small" class="delete" @click="delMulData">
        <i class="el-icon-delete"></i>删除
      </el-button>

      <el-button-group>
        <el-button type="primary" size="small" v-role="['1']" @click="approve" icon="el-icon-edit">通过审核</el-button>
        <el-button type="primary" size="small" v-role="['1']" @click="cancelApprove"
          icon="el-icon-share">取消审核</el-button>
        <el-button type="success" size="small" @click="download" icon="el-icon-download">下载报名</el-button>
        <el-button type="primary" size="small" v-if="exportMode != null && exportMode == 2" @click="downloadTeam"
          icon="el-icon-download">下载代表队报名表</el-button>
        <el-button type="warning" size="small" v-role="['1']" @click="downloadPlayer"
          icon="el-icon-download">下载选手名单</el-button>
      </el-button-group>

      <el-button type="primary" class="add" v-role="['1', '3']" size="small" @click="upload">
        <i class="el-icon-upload"></i>
        上传选手
      </el-button>
      <el-button type="primary" plain size="small" @click="showQrcode">
        <i class="el-icon-picture"></i>录选手二维码
      </el-button>
      <el-button type="primary" v-if="matchId==65" size="small" @click="downloadSecurityFile">
        <i class="el-icon-download"></i>下载安全承诺书
      </el-button>
    </div>
    <div>
      <div class="box">
        <el-form :inline="true" size="mini">
          <el-form-item label="代表队">
            <el-select v-model="searchForm.teamId" clearable style="width: 100%">
              <el-option v-for="item in teamOptions" :value="item.value" :label="item.name"
                :key="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="组别">
            <el-select v-model="searchForm.competitionGroupId" clearable style="width: 100%">
              <el-option v-for="item in groupSelectOptions" :value="item.value" :label="item.name"
                :key="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="审核状态">
            <el-select v-model="searchForm.status" clearable style="width: 100%">
              <el-option v-for="item in statusOptions" :value="item.value" :label="item.name"
                :key="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="关键字">
            <el-input placeholder="请输入姓名" clearable v-model="searchForm.keyword"></el-input>
          </el-form-item>
          <el-button type="primary" size="small" @click="searchdata" class="queryBtn">查询</el-button>
        </el-form>
      </div>
    </div>
    <el-table ref="multipleTable" :data="tableListData" tooltip-effect="dark" style="width: 100%; position: relative"
      :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
      <el-table-column type="selection" align="center"></el-table-column>
      <el-table-column prop="male" align="left" label="选手1"></el-table-column>
      <el-table-column prop="female" align="left" label="选手2"></el-table-column>
      <el-table-column prop="groupCode" align="center" label="组别代码" width="100"></el-table-column>
      <el-table-column prop="competitionGroupName" align="center" label="组别"></el-table-column>
      <el-table-column prop="danceType" align="center" label="舞种"></el-table-column>
      <el-table-column prop="teamName" align="center" label="代表队"></el-table-column>
      <el-table-column prop="entryFee" align="center" label="报名费" width="80" v-if="isSepecialUserHidden()"></el-table-column>
      <el-table-column prop="status" width="100" align="center" label="审核情况"
        :formatter="statusFormatter"></el-table-column>
      <el-table-column prop="operation" label="操作" fixed="right" width="100" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-button type="text" @click="deletePlayer(scope.row)" class="btnopt" size="small"
            v-if="scope.row.status == 0">删除</el-button>
          <el-button type="text" size="small" @click="editPlayer(scope.row)" class="btnopt"
            v-if="scope.row.status == 0 && scope.row.isRelated != true">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-bottom: 10px" v-if="isSepecialUserHidden()">
      <span>合计：</span><span style="color: red">{{ totalAmount }}</span> &nbsp;&nbsp;<span
        v-if="isShowRebate">返点：</span><span v-if="isShowRebate" style="color: red">{{ rebeateAmount }}</span>
    </div>
    <div class="paging">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="searchForm.page" :page-sizes="[15, 20, 50, 100]" :page-size="searchForm.pageSize" background
        layout="prev, pager, next,total, sizes, jumper" :total="total"></el-pagination>
    </div>
    <!--新增弹框-->
    <el-dialog :title="'报名单双人组'" :visible.sync="dialogSingleFormVisible">
      <div style="text-align: center; margin-bottom: 5px;">
        <el-radio-group v-model="singleDialogModel" size="mini"
          @change="() => { singleDialogModel == '手动输入' ? loadTeamPlayer(formSingleInput.teamId) : loadPlayerList(); }">
          <el-radio-button label="手动输入"></el-radio-button>
          <el-radio-button label="选择录入"></el-radio-button>
        </el-radio-group>
      </div>
      <el-form v-if="singleDialogModel == '选择录入'" :model="form" label-position="right" label-width="110px"
        :rules="formSingleRules" ref="formsingle">
        <el-form-item label="代表队" v-if="isAdmin()">
          <el-select v-model="form.teamId" filterable clearable placeholder="请输入代表队名称/领队/手机号" @change="loadTeamPlayer">
            <el-option v-for="item in teamListOptions" :value="item.value" :label="item.name"
              :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选手1(男步)" prop="male">
          <el-select @change="calcEntryFeeSingle" v-model="form.male" filterable clearable style="width: 100%">
            <el-option v-for="item in playerListSelector()" :value="item.value" :label="item.name"
              :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选手2(女步)" prop="female">
          <el-select @change="calcEntryFeeSingle" v-model="form.female" filterable clearable :disabled="isSingleGroup"
            style="width: 100%">
            <el-option v-for="item in playerListSelector()" :value="item.value" :label="item.name"
              :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="参赛组别" prop="competitionGroupId">
          <el-select multiple filterable clearable @change="calcEntryFeeSingle" v-model="form.competitionGroupId"
            style="width: 100%">
            <el-option v-for="item in groupOptionList" :value="item.value" :label="item.name" :key="item.value"
              :disabled="item.isDisabled"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报名费" prop="entryFee">
          <el-input v-model="form.entryFee" maxlength="255"></el-input>
        </el-form-item>
      </el-form>
      <el-form v-else :model="formSingleInput" label-position="right" label-width="110px" :rules="formSingleInputRules"
        ref="formSingleInput" size="mini">
        <el-form-item label="代表队">
          <el-select v-model="formSingleInput.teamId" filterable clearable placeholder="请选择代表队"
            @change="loadTeamPlayer">
            <el-option v-for="item in teamOptions" :value="item.value" :label="item.name" :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选手1(男步)" prop="malename">
          <el-row :gutter="10">
            <el-col :span="10">
              <el-input v-model="formSingleInput.malename" @change="calcEntryInputFeeSingle" clearable placeholder="请输入选手姓名"
                maxlength="18"></el-input>
              <!--<el-autocomplete v-model="formSingleInput.malename" :fetch-suggestions="querySinglePlayerSearch"
                popper-class="el-autocomplete-suggestion" :popper-append-to-body="false" placeholder="请输入选手姓名"
                @blur="calcEntryInputFeeSingle" @select="singleMaleSelect" clearable>
                <template slot-scope="{ item }">
                  <div class="name">{{ item.name }}</div>
                </template></el-autocomplete>-->
            </el-col>
            <el-col :span="10">
              <el-input v-model="formSingleInput.maleidentityNo" @change="calcEntryInputFeeSingle" clearable placeholder="请输入选手身份证"
                maxlength="18"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="选手2(女步)" prop="femalename">
          <el-row :gutter="10">
            <el-col :span="10">
              <el-input v-model="formSingleInput.femalename" @change="calcEntryInputFeeSingle" clearable placeholder="请输入选手姓名"
                maxlength="18"></el-input>
             <!--<el-autocomplete v-model="formSingleInput.femalename" :fetch-suggestions="querySinglePlayerSearch"
                popper-class="el-autocomplete-suggestion" :popper-append-to-body="false" placeholder="请输入选手姓名"
                @blur="calcEntryInputFeeSingle" @select="singleFemaleSelect" clearable>
                <template slot-scope="{ item }">
                  <div class="name">{{ item.name }}</div>
                </template></el-autocomplete>--> 
            </el-col>
            <el-col :span="10">
              <el-input v-model="formSingleInput.femaleidentityNo" @change="calcEntryInputFeeSingle" clearable placeholder="请输入选手身份证"
                maxlength="18"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="参赛组别" prop="competitionGroupId">
          <el-select multiple filterable clearable @change="calcEntryInputFeeSingle"
            v-model="formSingleInput.competitionGroupId" style="width: 100%">
            <el-option v-for="item in groupOptionList" :value="item.value" :label="item.name" :key="item.value"
              :disabled="item.isDisabled"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报名费" prop="entryFee">
          <el-input v-model="formSingleInput.entryFee" maxlength="255"></el-input>
        </el-form-item>
      </el-form>
      <div>
        <h5 style="margin: 5px 0px;">报名须知：</h5>
        <ul style="padding: 0px;margin: 0px;">
          <li>1.报名前请确认所报组别是否符合参赛规则。</li>
          <li>
            2.报名单人组别，选手不分性别都填“选手一”。
          </li>
          <li>
            3.报名男女组别或女双组别，请将男选手或男步选手填在“选手一”，女选手或女步选手填“选手二”。
          </li>
          <li>
            4.报名奖金组/精英组的选手，请先进行实名认证，才能报名相应的奖金组/精英组。
          </li>
        </ul>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogSingleFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitFormSingle" :loading="isLoading">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="'报名6-12人组'" :visible.sync="dialogGroupFormVisible">
      <div style="text-align: center; margin-bottom: 5px;">
        <el-radio-group v-model="groupDialogModel" size="mini"
          @change="() => { if (groupDialogModel == '手动输入') { loadTeamPlayer(formGroupInput.teamId); } else { loadPlayerList(); } }">
          <el-radio-button label="手动输入"></el-radio-button>
          <el-radio-button label="选择录入"></el-radio-button>
        </el-radio-group>
      </div>
      <div v-show="isGroupInput()">
        <el-form :model="form" label-position="right" label-width="110px" :rules="formgroupRules" ref="formGroupSelect">
          <el-form-item label="代表队" v-if="isAdmin()">
            <el-select v-model="form.teamId" filterable clearable placeholder="请输入代表队名称/领队/手机号"
              @change="loadTeamPlayer">
              <el-option v-for="item in teamListOptions" :value="item.value" :label="item.name"
                :key="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选手1(男步)" prop="male">
            <el-select multiple v-model="form.male" filterable clearable @change="calcEntryFeeGroup"
              style="width: 100%">
              <el-option v-for="item in playerListSelector()" :value="item.value" :label="item.name"
                :key="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选手2(女步)" prop="female">
            <el-select multiple v-model="form.female" filterable clearable @change="calcEntryFeeGroup"
              style="width: 100%">
              <el-option v-for="item in playerListSelector()" :value="item.value" :label="item.name"
                :key="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="参赛组别" prop="competitionGroupId">
            <el-select multiple @change="calcEntryFeeGroup" filterable clearable v-model="form.competitionGroupId"
              style="width: 100%">
              <el-option v-for="item in groupOptionList" :value="item.value" :label="item.name" :key="item.value"
                :disabled="item.isDisabled"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="报名费" prop="entryFee">
            <el-input v-model="form.entryFee" maxlength="255"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div v-show="!isGroupInput()">
        <el-form :model="formGroupInput" label-position="right" label-width="110px" :rules="formGroupInputRules"
          ref="formGroupInputRef" size="mini">
          <el-form-item label="代表队" v-if="groupDialogModel == '手动输入'">
            <el-select v-model="formGroupInput.teamId" filterable clearable placeholder="请选择代表队"
              @change="loadTeamPlayer">
              <el-option v-for="item in teamOptions" :value="item.value" :label="item.name"
                :key="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="'选手' + (index + 1) + '(男步)'" v-for="(player, index) in formGroupInput.males"
            :key="'gm' + index">
            <el-row :gutter="10">
              <el-col :span="10">
                <el-input v-model="player.name" placeholder="请输入选手姓名" @change="calcEntryFeeInputGroup" maxlength="255"></el-input>
               <!-- <el-autocomplete v-model="player.name" :fetch-suggestions="queryGroupPlayerSearch"
                  popper-class="el-autocomplete-suggestion" :popper-append-to-body="false" placeholder="请输入选手姓名"
                  @blur="calcEntryFeeInputGroup" @select="((item) => { groupPlayerSelect(item, player) })">
                  <template slot-scope="{ item }">
                    <div class="name">{{ item.name }}</div>
                  </template></el-autocomplete>-->
              </el-col>
              <el-col :span="10">
                <el-input v-model="player.identityNo"  @change="calcEntryFeeInputGroup"  placeholder="请输入选手身份证" maxlength="18"></el-input>
              </el-col>
              <el-col class="line" :span="2"><i class="el-icon-delete" @click="deleteGroupMalePlayerInput(index)"
                  title="删除"></i></el-col>
            </el-row>
          </el-form-item>
          <el-form-item>
            <el-button @click="addGroupMalePlayerInput" size="mini">增加男步选手</el-button>
          </el-form-item>
          <el-form-item :label="'选手' + (index + 1) + '(女步)'" v-for="(player, index) in formGroupInput.females"
            :key="'gf' + index">
            <el-row :gutter="10">
              <el-col :span="10">
                <el-input v-model="player.name" placeholder="请输入选手姓名" @change="calcEntryFeeInputGroup" maxlength="255"></el-input>
                <!--<el-autocomplete v-model="player.name" :fetch-suggestions="queryGroupPlayerSearch" clearable
                  popper-class="el-autocomplete-suggestion" :popper-append-to-body="false" placeholder="请输入选手姓名"
                  @blur="calcEntryFeeInputGroup" @select="((item) => { groupPlayerSelect(item, player) })">
                  <template slot-scope="{ item }">
                    <div class="name">{{ item.name }}</div>
                  </template></el-autocomplete>-->
              </el-col>
              <el-col :span="10">
                <el-input v-model="player.identityNo"  @change="calcEntryFeeInputGroup"  placeholder="请输入选手身份证" clearable maxlength="18"></el-input>
              </el-col>
              <el-col class="line" :span="2"><i class="el-icon-delete" @click="deleteGroupFemalePlayerInput(index)"
                  title="删除"></i></el-col>
            </el-row>
          </el-form-item>
          <el-form-item>
            <el-button @click="addGroupFemalePlayerInput" size="mini">增加女步选手</el-button>
          </el-form-item>
          <el-form-item label="参赛组别" prop="competitionGroupId">
            <el-select multiple @change="calcEntryFeeInputGroup" filterable clearable
              v-model="formGroupInput.competitionGroupId" style="width: 100%">
              <el-option v-for="item in groupOptionList" :value="item.value" :label="item.name" :key="item.value"
                :disabled="item.isDisabled"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="报名费" prop="entryFee">
            <el-input v-model="formGroupInput.entryFee" maxlength="255"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <h5 style="margin: 5px 0px;">报名须知：</h5>
        <ul style="padding: 0px;margin: 0px;">
          <li>1.报名前请确认所报组别是否符合参赛规则。</li>
          <li>2.请将选手分别填在对应的选手框里。</li>
          <li>3.如超过6人的组合，点击选手框下方的“增加男/女步选手”，增加选手框进行填写。</li>
        </ul>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogGroupFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitFormGroup" :loading="isLoading">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="'报名团体舞'" :visible.sync="dialogTeamFormVisible">
      <div style="text-align: center; margin-bottom: 5px;">
        <el-radio-group v-model="teamDialogModel" size="mini"
          @change="() => { teamDialogModel == '手动输入' ? loadTeamPlayer(formTeamInput.teamId) : loadPlayerList(); }">
          <el-radio-button label="手动输入"></el-radio-button>
          <el-radio-button label="选择录入"></el-radio-button>
        </el-radio-group>
      </div>
      <el-form :model="form" v-if="teamDialogModel == '选择录入'" label-position="right" label-width="110px"
        :rules="formRules" ref="formteam">
        <el-form-item label="代表队" v-if="isAdmin()">
          <el-select v-model="form.teamId" filterable clearable placeholder="请输入代表队名称/领队/手机号" @change="loadTeamPlayer">
            <el-option v-for="item in teamListOptions" :value="item.value" :label="item.name"
              :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="舞蹈名称" prop="male">
          <el-input v-model="form.male" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item>
          <el-transfer :titles="['选手', '已选择']" filterable :props="{ key: 'value', label: 'name' }"
            @change="calcEntryFeeTeam" v-model="form.female" filter-placeholder="请输入选手姓名" :data="playerListSelector()">
          </el-transfer>
        </el-form-item>
        <el-form-item label="参赛组别" prop="competitionGroupId">
          <el-select multiple filterable clearable @change="calcEntryFeeTeam" v-model="form.competitionGroupId"
            style="width: 100%">
            <el-option v-for="item in groupOptionList" :value="item.value" :label="item.name" :key="item.value"
              :disabled="item.isDisabled"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="报名费" prop="entryFee">
          <el-input v-model="form.entryFee" maxlength="255"></el-input>
        </el-form-item>
      </el-form>
      <el-form v-else :model="formTeamInput" label-position="right" label-width="110px" :rules="formTeamInputRules"
        ref="formTeamInput" size="mini">
        <el-form-item label="代表队">
          <el-select v-model="formTeamInput.teamId" filterable clearable placeholder="请输入代表队名称/领队/手机号"
            @change="loadTeamPlayer">
            <el-option v-for="item in teamOptions" :value="item.value" :label="item.name" :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="舞蹈名称" prop="male">
          <el-input v-model="formTeamInput.male" clearable maxlength="255"></el-input>
        </el-form-item>
        <el-form-item :label="'选手' + (index + 1)" v-for="(player, index) in formTeamInput.females" :key="index">
          <el-row :gutter="10">
            <el-col :span="10">
              <el-input v-model="player.name" clearable @change="calcEntryFeeInputTeam" placeholder="请输入选手身份证" maxlength="255"></el-input>
              <!--
              <el-autocomplete v-model="player.name" :fetch-suggestions="queryTeamPlayerSearch" clearable
                popper-class="el-autocomplete-suggestion" :popper-append-to-body="false" placeholder="请输入选手姓名"
                @blur="calcEntryFeeInputTeam" @select="((item) => { teamMaleSelect(item, player) })">
                <template slot-scope="{ item }">
                  <div class="name">{{ item.name }}</div>
                </template></el-autocomplete>-->
            </el-col>
            <el-col :span="10">
              <el-input v-model="player.identityNo" clearable @change="calcEntryFeeInputTeam" placeholder="请输入选手身份证" maxlength="18"></el-input>
            </el-col>
            <el-col class="line" :span="2"><i class="el-icon-delete" @click="deleteTeamPlayerInput(index)"
                title="删除"></i></el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-button @click="addTeamPlayerInput" size="mini">增加选手</el-button>
        </el-form-item>
        <el-form-item label="参赛组别" prop="competitionGroupId">
          <el-select multiple filterable clearable @change="calcEntryFeeInputTeam"
            v-model="formTeamInput.competitionGroupId" style="width: 100%">
            <el-option v-for="item in groupOptionList" :value="item.value" :label="item.name" :key="item.value"
              :disabled="item.isDisabled"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="报名费" prop="entryFee">
          <el-input v-model="formTeamInput.entryFee" maxlength="255"></el-input>
        </el-form-item>
      </el-form>
      <div>{{ calcTeamMessage }}</div>
      <div>
        <h5 style="margin: 5px 0px;">报名须知：</h5>
        <ul style="padding: 0px;margin: 0px;">
          <li>1.报名前请确认所报组别是否符合参赛规则。</li>
          <li>
            2.报名.团体舞/群舞/齐舞的选手，请在“舞蹈名称”中填写舞蹈节目的名称。
          </li>
          <li>
            3.选手名单在下方选手栏处填写，点击“增加选手”依次添加选手名单。
          </li>
        </ul>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTeamFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitFormTeam" :loading="isLoading">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="'选手导入'" :inline="true" :visible.sync="dialogImportFormVisible">
      <el-form :model="formImport" label-position="right" label-width="110px" :rules="formRules" ref="formImport">
        <!--<el-form-item label="代表队">
        <el-select v-model="teamId">
          <el-option
            v-for="item in teamListOptions"
            :value="item.value"
            :label="item.name"
            :key="item.value"
          ></el-option>
        </el-select>
      </el-form-item>-->
        <el-form-item>
          <el-upload ref="uploader" class="upload-demo" action=""
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            :http-request="uploadFile" :limit="1">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传Excel文件</div>
          </el-upload>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :title="'批量报名'" :inline="true" :visible.sync="dialogImportBatchFormVisible">
      <el-steps :active="active" finish-status="success">
        <el-step title="上传"> </el-step>
        <el-step title="确认"> </el-step>
        <el-step title="完成"></el-step>
      </el-steps>
      <el-form v-if="active == 0" :model="formImport" label-position="right" label-width="110px" :rules="formRules"
        ref="formImport">
        <el-form-item label="代表队">
          <el-select v-model="teamId">
            <el-option v-for="item in teamListOptions" :value="item.value" :label="item.name"
              :key="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-upload ref="uploaderBatch" class="upload-demo" action=""
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            :http-request="uploadBatchFile" :limit="1">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传Excel文件</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div v-if="active == 1">
        <el-table height="400" ref="multipleTableimport" :data="tableData" @selection-change="handleSelectionChange1"
          style="width: 100%">
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column label="男选手">
            <template slot-scope="scope">
              <div v-for="item in scope.row.males">
                <span>{{ item.name }}</span>
                <span v-if="item.identityNo != null && item.identityNo != ''">{{
        item.identityNo
      }}</span>
                <span v-if="item.isIdentityValidated">
                  <i class="el-icon-check" style="color: #67c23a"></i>
                </span>
                <el-button size="mini" v-if="scope.row.isNeedIdentity && !item.isIdentityValidated"
                  @click="identityValidate(item)" type="warning">认证</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="女选手">
            <template slot-scope="scope">
              <div v-for="item in scope.row.females">
                <span>{{ item.name }}</span>
                <span v-if="item.identityNo != null && item.identityNo != ''">{{
        item.identityNo
      }}</span>
                <span v-if="item.isIdentityValidated">
                  <i class="el-icon-check" style="color: #67c23a"></i>
                </span>
                <el-button size="mini" v-if="scope.row.isNeedIdentity && !item.isIdentityValidated"
                  @click="identityValidate(item)" type="warning">认证</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="competitonGroupName" label="组别">
          </el-table-column>
          <el-table-column prop="competitionGroupCode" label="组别代码">
          </el-table-column>
          <el-table-column prop="danceType" label="舞种"> </el-table-column>
          <el-table-column prop="entryFee" label="报名费"> </el-table-column>
          <el-table-column label="消息">
            <template slot-scope="scope">
              <span style="color: red">{{ scope.row.message }}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-button style="margin: 0 10" @click="submitImport" type="primary">提交</el-button>
      </div>
      <div v-if="active == 2"></div>
    </el-dialog>
    <el-dialog :title="'实名认证'" :inline="true" :visible.sync="dialogValidateFormVisible">
      <el-form :model="formIdentity" label-position="right" label-width="110px" :rules="formIdentityRules"
        ref="formIdentity">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="formIdentity.name" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="证件类型" prop="identityType">
          <el-radio-group v-model="formIdentity.identityType">
            <el-radio :label="1">身份证</el-radio>
            <el-radio :label="2">户口</el-radio></el-radio-group>
        </el-form-item>
        <el-form-item label="证件号码" prop="identityNo">
          <el-input v-model="formIdentity.identityNo" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item prop="fileurl">
          <el-upload v-if="formIdentity.identityType == 2" ref="upload" action=""
            accept="image/png,image/gif,image/jpg,image/jpeg" :limit="1" :http-request="uploadEditFile">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，且不超过500kb
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div style="color: #ffa500">有身份证号即可身份证验证，否则上传护照</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogValidateFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitFormIdentity" :loading="isLoading">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="'选手录入二维码生成'" :inline="true" :visible.sync="dialogQRCodeVisible">
      <div style="text-align: center">
        <el-select v-model="QrcodeTeamId" @change="changeQrcodeTeam">
          <el-option v-for="item in teamOptions" :value="item.value" :label="item.name" :key="item.value"></el-option>
        </el-select>
      </div>
      <div style="text-align: center">
        <el-image :src="QRCodeUrl"></el-image>
      </div>
      <div style="text-align: center">
        <span>{{ QRCodeText }}</span>
        <el-button type="primary" size="medium" @click="copyClipboard">复制</el-button>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogQRCodeVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import QRCode from "qrcode";
import GroupApi from "../apis/group";
import PlayerApi from "../apis/player";
import API from "../apis/playermatch";
import TM from "../apis/teamMatch";
import TMC from "../apis/teamregistrationconfig";
import MAPI from "../apis/match";
import RULE from "../apis/matchrule";
import md5 from "../utils/md5";
import axios from "axios";
export default {
  props: ["matchId"],
  data() {
    const validSingleForm = (rule, value, callback) => {
      if (value === null || value.length < 1) {
        callback(new Error("请选择组别"));
      }
      var singleArray = [];
      var len = this.form.competitionGroupId.length;
      for (var j = 0; j < len; j++) {
        var cur = this.groupOptionList.find((item) => {
          if (item.value == this.form.competitionGroupId[j]) {
            return item;
          }
        });
        if (cur != null && cur.groupType.indexOf("单人") != -1) {
          singleArray.push(this.form.competitionGroupId[j]);
        }
      }
      var sig = Object.assign(singleArray).length;
      if (len > sig && sig > 0) {
        callback(new Error("单人组和双人组无法同时报"));
      } else {
        callback();
      }
    };
    const validSingleFemale = (rule, value, callback) => {
      if (this.isSingleGroup) {
        callback();
      } else {
        if (value === null || value.length < 1) {
          callback(new Error("请选择选手"));
        }
        var singleArray = [];
        var len = this.form.competitionGroupId.length;
        for (var j = 0; j < len; j++) {
          var cur = this.groupOptionList.find((item) => {
            if (item.value == this.form.competitionGroupId[j]) {
              return item;
            }
          });
          if (cur != null && cur.groupType.indexOf("单人") != -1) {
            singleArray.push(this.form.competitionGroupId[j]);
          }
        }
        var sig = Object.assign(singleArray).length;
        if (len - sig > 0 && value == "") {
          callback(new Error("请选择选手"));
        } else {
          callback();
        }
      }
    };

    const validSingleMale = (rule, value, callback) => {
      if (value === null || value.length < 1) {
        callback(new Error("请选择选手"));
      }
      var singleArray = [];
      var len = this.form.competitionGroupId.length;
      for (var j = 0; j < len; j++) {
        var cur = this.groupOptionList.find((item) => {
          if (item.value == this.form.competitionGroupId[j]) {
            return item;
          }
        });
        if (cur != null && cur.groupType.indexOf("单人") != -1) {
          singleArray.push(this.form.competitionGroupId[j]);
        }
      }
      var sig = Object.assign(singleArray).length;

      if (len - sig > 0) {
        var male = this.playerList.find((item) => {
          if (item.value == this.form.male) return item;
        });
        var isNeed = false;
        for (var i = 0; i < this.form.competitionGroupId.length; i++) {
          var curr = this.groupOptionList.find((item) => {
            if (item.value == this.form.competitionGroupId[i]) return item;
          });
          if (curr != null && curr.isMaleSex == true) {
            isNeed = true;
            break;
          }
        }
        if (male.sex != 1 && isNeed) {
          callback(new Error("选手1需为男性选手"));
        }
      }
      callback();
    };

    return {
      singleDialogModel: '手动输入',
      groupDialogModel: '手动输入',
      teamDialogModel: '手动输入',
      teamListOptions: [],
      lastSelected: [],
      teamId: null,
      isLoading: false,
      exportMode: null,
      isSingleGroup: false,
      dialogFormVisible: false,
      dialogEditFormVisible: false,
      dialogSingleFormVisible: false,
      dialogTeamFormVisible: false,
      dialogGroupFormVisible: false,
      dialogImportFormVisible: false,
      dialogImportBatchFormVisible: false,
      dialogValidateFormVisible: false,
      dialogQRCodeVisible: false,
      active: 0,
      calcTeamMessage: "",
      tableData: [],
      multipleSelection: [],
      multipleSelection2: [],
      teamOptions: [],
      totalAmount: 0,
      rebeateAmount: 0,
      isShowRebate: false,
      isNeedIdentity: false,
      total: 0,
      playerList: null,
      compose: [],
      tableListData: [],
      groupOptionList: [],
      currentPlayer: {},
      groupSelectOptions: [],
      QRCodeUrl: "",
      QRCodeText: "",
      QrcodeTeamId: null,
      statusOptions: [{ name: "全部", value: "" }, { name: "未审核", value: "0" }, { name: "已审核", value: "1" }],
      formImport: { matchId: this.matchId, teamId: null },
      formIdentity: {
        id: 0,
        name: "",
        identityNo: null,
        identityType: 2,
        fileurl: null,
      },
      formIdentityRules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        identityNo: [{ validator: this.validID2, trigger: "blur" }],
        fileurl: [{ required: true, message: "请选择护照文件", validator: this.validatePassport, trigger: "change" }]
      },
      teamRegistrationConfig: [],
      searchForm: {
        matchId: this.matchId,
        teamId: null,
        status: null,
        competitionGroupId: null,
        keyword: null,
        page: 1,
        pageSize: 15,
      },
      form: {
        id: 0,
        male: null,
        female: null,
        competitionGroupId: null,
        entryFee: "",
        type: 1,
      },
      formGroup: {
        id: 0,
        male: [],
        female: [],
        competitionGroupId: [],
        entryFee: "",
        type: 1,
      },
      formSingleInput: {
        id: 0,
        maleid: 0,
        teamId: null,
        malename: '',
        maleidentityNo: '',
        femaleid: 0,
        femalename: '',
        femaleidentityNo: '',
        competitionGroupId: null,
        entryFee: "",
        type: 1,
      },
      formGroupInput: {
        id: 0, teamId: null,
        males: [{ id: 0, name: '', identityNo: '' }],
        females: [{ id: 0, name: '', identityNo: '' }],
        competitionGroupId: null, entryFee: "", type: 2
      },
      formTeamInput: { id: 0, teamId: null, male: '', females: [{ id: 0, name: '', identityNo: '' }], competitionGroupId: null, entryFee: "", type: 3 },
      formSingleInputRules: {
        malename: [{ required: true, message: "请输入选手", trigger: "blur" }], competitionGroupId: [{ required: true, message: "请选择组别", trigger: "blur" }],
      },
      formGroupInputRules: { competitionGroupId: [{ required: true, message: "请选择组别", trigger: "blur" }] },
      formTeamInputRules: {
        male: [{ required: true, message: "请输入舞蹈名称", trigger: "blur" }], competitionGroupId: [{ required: true, message: "请选择组别", trigger: "blur" },
        ]
      },
      formRules: {
        female: [{ required: true, message: "请输入选手", trigger: "blur" }], male: [{ required: true, message: "请输入选手", trigger: "blur" }], competitionGroupId: [
          { required: true, message: "请选择组别", trigger: "blur" },
        ]
      },
      formgroupRules: {
        male: [{ required: true, message: "请输入选手", trigger: "blur" }],
        competitionGroupId: [
          { required: true, message: "请选择组别", trigger: "blur" },
        ],
      },
      formSingleRules: {
        male: [
          { required: true, message: "请输入选手", trigger: "blur" },
          { validator: validSingleMale, trigger: "blur" },
        ],
        female: [{ validator: validSingleFemale, trigger: "blur" }],
        competitionGroupId: [
          { required: true, message: "请选择组别", trigger: "blur" },
          { validator: validSingleForm, trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    isSepecialUserHidden(){
      if( sessionStorage.getItem('uid')==='2077')
      {
        return false;
      }
      return true;
    },
    isGroupInput() {
      return this.groupDialogModel == '选择录入';
    },
    downloadSecurityFile(){
      let url = 'https://bm.lwdance.top/files/2024年中国重庆体育舞蹈公开赛安全承诺书.docx';
      axios.get(url, {
        responseType: 'blob',
        timeout: 20000,
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data],
            { type: 'application/octet-stream' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', '2024年中国重庆体育舞蹈公开赛安全承诺书.docx');
        document.body.appendChild(link);
        link.click();
    });
    },
    groupPlayerSelect(item, player) {
      var name = item.name.split(' ');
      player.name = name[0];
      player.id = parseInt(item.value);
      player.identityNo = name[2];
    },
    teamMaleSelect(item, player) {
      var name = item.name.split(' ');
      player.name = name[0];
      player.id = parseInt(item.value);
      player.identityNo = name[2];
    },
    singleMaleSelect(item) {
      var name = item.name.split(' ');
      this.formSingleInput.malename = name[0];
      this.formSingleInput.maleid = parseInt(item.value);
      this.formSingleInput.maleidentityNo = name[2];
    },
    singleFemaleSelect(item) {
      var name = item.name.split(' ');
      this.formSingleInput.femalename = name[0];
      this.formSingleInput.femaleid = parseInt(item.value);
      this.formSingleInput.femaleidentityNo = name[2];
    },
    querySinglePlayerSearch(queryString, cb) {
      var results = queryString ? this.playerList.filter(s => s.teamId == this.formSingleInput.teamId && s.name.indexOf(queryString) === 0) : this.playerList.filter(s => s.teamId == this.formSingleInput.teamId);
      if (this.isNeedIdentity) {
        results = results.filter(s => s.identityInput);
      }
      if (this.isIdentityValidated) {
        results = results.filter(s => s.isIdentityValidated);
      }
      cb(results);
    },
    queryGroupPlayerSearch(queryString, cb) {
      var results = queryString ? this.playerList.filter(s => s.teamId == this.formGroupInput.teamId && s.name.indexOf(queryString) === 0) : this.playerList.filter(s => s.teamId == this.formGroupInput.teamId);
      if (this.isNeedIdentity) {
        results = results.filter(s => s.identityInput);
      }
      if (this.isIdentityValidated) {
        results = results.filter(s => s.isIdentityValidated);
      }
      cb(results);
    },
    queryTeamPlayerSearch(queryString, cb) {
      var results = queryString ? this.playerList.filter(s => s.teamId == this.formTeamInput.teamId && s.name.indexOf(queryString) === 0) : this.playerList.filter(s => s.teamId == this.formTeamInput.teamId);
      if (this.isNeedIdentity) {
        results = results.filter(s => s.identityInput);
      }
      if (this.isIdentityValidated) {
        results = results.filter(s => s.isIdentityValidated);
      }
      cb(results);
    },
    async validatePassport(rule, value, callback) {
      if (this.formIdentity.identityType == 2) {
        if (value != null && value != "") {
          callback();
        } else {
          callback(new Error("请上传护照"));
        }
      } else {
        callback();
      }
    },
    playerListSelector() {
      if (this.isNeedIdentity) {
        if(this.playerList!=null)
        return this.playerList.filter(s => s.identityInput);
      }
      return this.playerList;
    },
    showQrcode() {
      this.dialogQRCodeVisible = true;
      this.QrcodeTeamId = this.teamOptions[0].value;
      this.changeQrcodeTeam(this.QrcodeTeamId);
    },
    getQRcode() {
      QRCode.toDataURL(
        this.QRCodeText,
        { errorCorrectionLevel: "h", margin: 2, width: 128 },
        (err, url) => {
          this.QRCodeUrl = url;
        }
      );
    },
    changeQrcodeTeam(val) {
      let stringSignTemp =
        "liangwudance&matchId=" + this.matchId + "&teamId=" + val;
      let signData = md5.hexMD5Helper(stringSignTemp).toUpperCase();
      var url =
        "https://bm.lwdance.top/player/playerinfo?matchId=" +
        this.matchId +
        "&teamId=" +
        val +
        "&sign=" +
        signData;
      this.QRCodeText = url;
      this.getQRcode();
    },
    copyClipboard() {
      this.$copyText(this.QRCodeText).then(
        (e) => {
          this.$message.success("内容已复制到剪切板！");
        },
        (e) => {
          this.$message.error("抱歉，复制失败！");
        }
      );
    },
    isAdmin() {
      return sessionStorage.getItem("userType") == "1";
    },
    importBatch() {
      this.dialogImportBatchFormVisible = true;
      this.active = 0;
      this.$nextTick(() => {
        this.$refs["uploaderBatch"].clearFiles();
      });
    },
    handleSelectionChange1(val) {
      this.multipleSelection2 = val;
    },
    submitImport() {
      if (
        this.multipleSelection2 == null ||
        this.multipleSelection2.length < 1
      ) {
        this.$message.error({ showClose: true, message: "请选择要报名的选手", duration: 2000 });
        return;
      }
      let that = this;
      this.isLoading = true;
      var params = { players: this.multipleSelection2, matchId: this.matchId, teamId: this.teamId == null ? 0 : this.teamId };
      for (var i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].isNeedIdentity) {
          for (var j = 0; j < this.tableData[i].males.length; j++) {
            if (!this.tableData[i].males[j].isIdentityValidated) {
              this.$message.error({
                showClose: true,
                message: this.tableData[i].males[j].name + "未实名认证",
                duration: 2000,
              });
              this.isLoading = false;
              return;
            }
          }
          for (var j = 0; j < this.tableData[i].females.length; j++) {
            if (!this.tableData[i].females[j].isIdentityValidated) {
              this.$message.error({
                showClose: true,
                message: this.tableData[i].females[j].name + "未实名认证",
                duration: 2000,
              });
              this.isLoading = false;
              return;
            }
          }
        }
      }
      API.addBatch(params)
        .then(
          (data) => {
            if (data.code == 0) {
              that.$message.success({
                showClose: true,
                message: "报名成功",
                duration: 2000,
              });
              that.dialogImportBatchFormVisible = false;
              that.search();
              that.multipleSelection2 = [];
            } else {
              this.$message.error({
                showClose: true,
                message: data.message,
                duration: 2000,
              });
            }
            that.isLoading = false;
          },
          function (err) {
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000,
            });
            that.isLoading = false;
          }
        )
        .catch(function (error) {
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000,
          });
          that.isLoading = false;
        });
    },
    uploadEditFile: function (param) {
      this.uploading = true;
      var fileObj = param.file;
      var form = new FormData();
      form.append("file", fileObj);
      var that = this;
      API.upload(form)
        .then((result) => {
          if (result.code == 0) {
            that.$message.success({
              showClose: true,
              message: "上传成功",
              duration: 2000,
            });
            that.formIdentity.fileurl = result.result;
          } else {
            that.$message.error({
              showClose: true,
              message: "上传失败",
              duration: 2000,
            });
          }
        })
        .catch((error) => {
          that.$message.error({
            showClose: true,
            message: "请求异常",
            duration: 2000,
          });
        });
    },
    beforeupload(file) {
      this.formIdentity.file = file;
      return false;
    },
    identityValidate(player) {
      this.dialogValidateFormVisible = true;
      this.formIdentity.name = player.name;
      this.formIdentity.identityType = player.identityType;
      this.formIdentity.identityNo = player.identityNo;
      this.currentPlayer = player;
    },
    submitFormIdentity() {
      let that = this;
      this.isLoading = true;
      this.$refs.formIdentity.validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.formIdentity);
          if (params.identityType == 2) {
            API.validateHouseHold(params)
              .then(
                (data) => {
                  if (data.code == 0) {
                    this.currentPlayer.isIdentityValidated = true;
                    this.currentPlayer.sex = data.result.sex;
                    this.currentPlayer.birthday = data.result.birthday;
                    this.currentPlayer.province = data.result.province;
                    this.currentPlayer.city = data.result.city;
                    this.currentPlayer.area = data.result.area;
                    this.currentPlayer.identityNo = data.result.identityNo;
                    this.currentPlayer.name = data.result.name;
                    that.$message.success({
                      showClose: true,
                      message: "认证成功",
                      duration: 2000,
                    });
                    that.dialogValidateFormVisible = false;
                    that.$refs["formIdentity"].resetFields();
                  } else {
                    this.$message.error({
                      showClose: true,
                      message: data.message,
                      duration: 2000,
                    });
                  }
                  that.isLoading = false;
                },
                function (err) {
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000,
                  });
                  that.isLoading = false;
                }
              )
              .catch(function (error) {
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000,
                });
                that.isLoading = false;
              });
          } else {
            API.validate(params)
              .then(
                (data) => {
                  if (data.code == 0) {
                    that.$message.success({
                      showClose: true,
                      message: "认证成功",
                      duration: 2000,
                    });
                    that.dialogValidateFormVisible = false;
                    that.$refs["formIdentity"].resetFields();
                    this.currentPlayer.isIdentityValidated = true;
                    this.currentPlayer.sex = data.result.sex;
                    this.currentPlayer.birthday = data.result.birthday;
                    this.currentPlayer.province = data.result.province;
                    this.currentPlayer.city = data.result.city;
                    this.currentPlayer.area = data.result.area;
                    this.currentPlayer.identityNo = data.result.identityNo;
                    this.currentPlayer.name = data.result.name;
                  } else {
                    this.$message.error({
                      showClose: true,
                      message: data.message,
                      duration: 2000,
                    });
                  }
                  that.isLoading = false;
                },
                function (err) {
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000,
                  });
                  that.isLoading = false;
                }
              )
              .catch(function (error) {
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000,
                });
                that.isLoading = false;
              });
          }
        } else {
          that.isLoading = false;
        }
      });
    },
    upload() {
      this.dialogImportFormVisible = true;
      this.$nextTick(() => {
        this.$refs["formImport"].resetFields();
        this.$refs["uploader"].clearFiles();
      });
    },
    uploadBatchFile(item) {
      let that = this;
      const form = new FormData();
      form.append("file1", item.file);
      form.append("teamId", this.teamId == null ? 0 : this.teamId);
      form.append("matchId", this.matchId);
      API.importBatch(form)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.result;
            this.$message({
              type: "success",
              message: "导入成功!",
            });
            this.active = 1;
            this.$nextTick(() => {
              that.tableData.forEach((item) => {
                if (item.isOk) {
                  that.$refs.multipleTableimport.toggleRowSelection(item);
                }
              });
            });
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => { });
    },
    uploadFile(item) {
      const form = new FormData();
      form.append("matchId", this.matchId);
      form.append("file1", item.file);
      API.import(form)
        .then((res) => {
          if (res.code == 0) {
            this.$message({
              type: "success",
              message: "导入成功!",
            });
            this.search();
            this.dialogImportFormVisible = false;
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        })
        .catch((err) => { });
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "warning-row";
      } else {
        return "success-row";
      }
    },
    downloadTeam() {
      let params = Object.assign({}, this.searchForm);
      if (this.exportMode != null && this.exportMode == 2) {
        if (this.searchForm.teamId == null || this.searchForm.teamId < 1) {
          this.$alert("请选择代表队导出", "提示", {
            confirmButtonText: "确定",
          });
          return;
        }
      }
      API.downloadMore(params).then((res) => {
        var content = res;
        var blob = new Blob([content], {
          type: "application/vnd.ms-excel;charset=utf-8",
        });
        var fileName = "在线报名表.xls"; //要保存的文件名称
        if ("download" in document.createElement("a")) {
          var elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href);
          document.body.removeChild(elink);
        } else {
          navigator.msSaveBlob(blob, fileName);
        }
      });
    },
    download() {
      let params = Object.assign({}, this.searchForm);
      let that = this;
      API.download(params).then((res) => {
        var content = res;
        if (Object.prototype.toString.call(res) === '[object Blob]') {
          if (res.type.includes('application/json')) {
            const reader = new FileReader();
            reader.readAsText(res, "utf-8");
            reader.onload = function (e) {
              const result = JSON.parse(e.target.result);
              if (result.code === 413) {
                that.$message({
                  type: "warn",
                  message: "禁止下载!",
                });
              }
            };
          }
          else {
            var blob = new Blob([content], {
              type: "application/vnd.ms-excel;charset=utf-8",
            });
            var fileName = "在线报名表.xls"; //要保存的文件名称
            if ("download" in document.createElement("a")) {
              var elink = document.createElement("a");
              elink.download = fileName;
              elink.style.display = "none";
              elink.href = URL.createObjectURL(blob);
              document.body.appendChild(elink);
              elink.click();
              URL.revokeObjectURL(elink.href);
              document.body.removeChild(elink);
            } else {
              navigator.msSaveBlob(blob, fileName);
            }
          }
        }
      });
    },
    downloadPlayer() {
      API.downloadPlayer({ matchId: this.matchId }).then((res) => {
        var content = res;
        var blob = new Blob([content], {
          type: "application/vnd.ms-excel;charset=utf-8",
        });
        var fileName = "选手名单.xls"; //要保存的文件名称
        if ("download" in document.createElement("a")) {
          var elink = document.createElement("a");
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href);
          document.body.removeChild(elink);
        } else {
          navigator.msSaveBlob(blob, fileName);
        }
      });
    },
    statusFormatter(row, column) {
      switch (row.status) {
        case 0:
          return "上报成功";
        case 1:
          return "通过审核";
        case 2:
          return "否决";
      }
    },
    calcEntryInputFeeSingle(item) {
      let that = this;
      var player = [];
      if (this.formSingleInput.malename != "") {
        player.push({ id: parseInt(this.formSingleInput.maleid), name: this.formSingleInput.malename, identityNo: this.formSingleInput.maleidentityNo });
      }
      if (this.formSingleInput.femalename != '') {
        player.push({ id: parseInt(this.formSingleInput.femaleid), name: this.formSingleInput.femalename, identityNo: this.formSingleInput.femaleidentityNo });
      }
      GroupApi.selectInput({
        matchId: this.matchId,
        type: 1,
        playerIds: JSON.stringify(player)
      }).then((res) => {
        that.$nextTick(() => {
          that.groupOptionList = res.result;
          if (
            that.formSingleInput.competitionGroupId != null &&
            that.formSingleInput.competitionGroupId.length > 0
          ) {
            var singleArray = [];
            for (var j = 0; j < that.formSingleInput.competitionGroupId.length; j++) {
              var cur = that.groupOptionList.find((item) => {
                if (item.value == that.formSingleInput.competitionGroupId[j]) {
                  return item;
                }
              });
              if (cur == null) {
                that.formSingleInput.competitionGroupId.splice(j, 1);
              }
              if (cur.groupType.indexOf("单人") != -1) {
                singleArray.push(that.formSingleInput.competitionGroupId[j]);
              }
            }
            if (
              that.formSingleInput.competitionGroupId.length >= singleArray.length &&
              singleArray.length > 0
            ) {
              this.isSingleGroup = true;
              this.formSingleInput.femalename = '';
              this.formSingleInput.femaleidentityNo = '';
              this.formSingleInput.competitionGroupId = singleArray;
            } else {
              that.isSingleGroup = false;
            }
          }
          if (item != undefined && item != null && item instanceof Array) {
            var tempArr = item;
            if (item == undefined || item == null) {
              tempArr = [];
            }
            if (this.compose != null && this.compose.length > 0) {
              for (var i = 0; i < this.compose.length; i++) {
                if (
                  this.formSingleInput.competitionGroupId != null &&
                  this.formSingleInput.competitionGroupId.length > 0
                ) {
                  for (
                    var j = 0;
                    j < this.formSingleInput.competitionGroupId.length;
                    j++
                  ) {
                    if (
                      ("," + this.compose[i].competitionGroupId + ",").indexOf(
                        "," + this.formSingleInput.competitionGroupId[j] + ","
                      ) != -1
                    ) {
                      var ids = this.compose[i].competitionGroupId.split(",");
                      if (
                        this.lastSelected != null &&
                        this.lastSelected.length > 0 &&
                        ids.filter((s) => this.lastSelected.indexOf(s) > -1)
                          .length >
                        ids.filter(
                          (s) => this.formSingleInput.competitionGroupId.indexOf(s) > -1
                        ).length
                      ) {
                        for (var k = 0; k < ids.length; k++) {
                          if (tempArr.includes(ids[k])) {
                            tempArr.splice(tempArr.indexOf(ids[k]), 1);
                          }
                        }
                      } else {
                        for (var k = 0; k < ids.length; k++) {
                          if (!tempArr.includes(ids[k])) {
                            tempArr.push(ids[k]);
                          }
                        }
                      }
                    }
                  }
                }
              }
              this.formSingleInput.competitionGroupId = tempArr;
            }
          }
          var amount = 0;
          if (
            that.formSingleInput.competitionGroupId != null &&
            that.formSingleInput.competitionGroupId.length > 0
          ) {
            for (var i = 0; i < this.formSingleInput.competitionGroupId.length; i++) {
              for (var j = 0; j < this.groupOptionList.length; j++) {
                if (
                  this.formSingleInput.competitionGroupId[i] ==
                  this.groupOptionList[j].value
                ) {
                  if (this.groupOptionList[j].type === 1) {
                    if (this.formSingleInput.malename != null && this.formSingleInput.malename != "") {
                      amount += this.groupOptionList[j].amount;
                    }
                    if (this.form.femalename != null && this.form.femalename != "") {
                      amount += this.groupOptionList[j].amount;
                    }
                  } else {
                    amount += this.groupOptionList[j].amount;
                  }
                }
              }
            }
          }
          that.formSingleInput.entryFee = amount;
          that.lastSelected = [].concat(that.formSingleInput.competitionGroupId);
        });
      });
    },
    calcEntryFeeSingle(item) {
      let that = this;
      var player = [];
      if (this.form.male != "") {
        player.push(this.form.male);
      }
      if (this.form.female) {
        player.push(this.form.female);
      }
      GroupApi.select({
        matchId: this.matchId,
        type: 1,
        playerIds: player.toString(),
      }).then((res) => {
        that.$nextTick(() => {
          that.groupOptionList = res.result;
          if (
            that.form.competitionGroupId != null &&
            that.form.competitionGroupId.length > 0
          ) {
            var singleArray = [];
            for (var j = 0; j < that.form.competitionGroupId.length; j++) {
              var cur = that.groupOptionList.find((item) => {
                if (item.value == that.form.competitionGroupId[j]) {
                  return item;
                }
              });
              if (cur == null) {
                that.form.competitionGroupId.splice(j, 1);
              }
              if (cur.groupType.indexOf("单人") != -1) {
                singleArray.push(that.form.competitionGroupId[j]);
              }
            }
            if (
              that.form.competitionGroupId.length >= singleArray.length &&
              singleArray.length > 0
            ) {
              this.isSingleGroup = true;
              this.form.female = null;
              this.form.competitionGroupId = singleArray;
            } else {
              that.isSingleGroup = false;
            }
          }
          if (item != undefined && item != null && item instanceof Array) {
            var tempArr = item;
            if (item == undefined || item == null) {
              tempArr = [];
            }
            if (this.compose != null && this.compose.length > 0) {
              for (var i = 0; i < this.compose.length; i++) {
                if (
                  this.form.competitionGroupId != null &&
                  this.form.competitionGroupId.length > 0
                ) {
                  for (
                    var j = 0;
                    j < this.form.competitionGroupId.length;
                    j++
                  ) {
                    if (
                      ("," + this.compose[i].competitionGroupId + ",").indexOf(
                        "," + this.form.competitionGroupId[j] + ","
                      ) != -1
                    ) {
                      var ids = this.compose[i].competitionGroupId.split(",");
                      if (
                        this.lastSelected != null &&
                        this.lastSelected.length > 0 &&
                        ids.filter((s) => this.lastSelected.indexOf(s) > -1)
                          .length >
                        ids.filter(
                          (s) => this.form.competitionGroupId.indexOf(s) > -1
                        ).length
                      ) {
                        for (var k = 0; k < ids.length; k++) {
                          if (tempArr.includes(ids[k])) {
                            tempArr.splice(tempArr.indexOf(ids[k]), 1);
                          }
                        }
                      } else {
                        for (var k = 0; k < ids.length; k++) {
                          if (!tempArr.includes(ids[k])) {
                            tempArr.push(ids[k]);
                          }
                        }
                      }
                    }
                  }
                }
              }
              this.form.competitionGroupId = tempArr;
            }
          }
          var amount = 0;
          if (
            that.form.competitionGroupId != null &&
            that.form.competitionGroupId.length > 0
          ) {
            for (var i = 0; i < this.form.competitionGroupId.length; i++) {
              for (var j = 0; j < this.groupOptionList.length; j++) {
                if (
                  this.form.competitionGroupId[i] ==
                  this.groupOptionList[j].value
                ) {
                  if (this.groupOptionList[j].type === 1) {
                    if (this.form.male != null && this.form.male != "") {
                      amount += this.groupOptionList[j].amount;
                    }
                    if (this.form.female != null && this.form.female != "") {
                      amount += this.groupOptionList[j].amount;
                    }
                  } else {
                    amount += this.groupOptionList[j].amount;
                  }
                }
              }
            }
          }
          that.form.entryFee = amount;
          that.lastSelected = [].concat(that.form.competitionGroupId);
        });
      });
    },
    calcEntryFeeGroupSingle(item) {
      let that = this;
      var singleArray = [];
      var total = Object.assign(item).length;
      for (var j = 0; j < item.length; j++) {
        var cur = that.groupOptionList.find((currentItem) => {
          if (currentItem.value == item[j]) {
            return currentItem;
          }
        });
        if (cur != null && cur.groupType.indexOf("单人") != -1) {
          singleArray.push(item[j]);
        }
      }
      var sig = Object.assign(singleArray).length;
      if (total >= sig && sig > 0) {
        this.isSingleGroup = true;
        this.form.female = null;
        this.form.competitionGroupId = singleArray;
      } else {
        that.isSingleGroup = false;
      }
      if (item != undefined && item != null && item instanceof Array) {
        var tempArr = item;
        if (item == undefined || item == null) {
          tempArr = [];
        }
        if (that.compose != null && that.compose.length > 0) {
          for (var i = 0; i < that.compose.length; i++) {
            if (
              that.form.competitionGroupId != null &&
              that.form.competitionGroupId.length > 0
            ) {
              for (var j = 0; j < that.form.competitionGroupId.length; j++) {
                if (
                  ("," + that.compose[i].competitionGroupId + ",").indexOf(
                    "," + that.form.competitionGroupId[j] + ","
                  ) != -1
                ) {
                  var ids = that.compose[i].competitionGroupId.split(",");
                  if (
                    that.lastSelected != null &&
                    that.lastSelected.length > 0 &&
                    ids.filter((s) => that.lastSelected.indexOf(s) > -1)
                      .length >
                    ids.filter(
                      (s) => that.form.competitionGroupId.indexOf(s) > -1
                    ).length
                  ) {
                    for (var k = 0; k < ids.length; k++) {
                      if (tempArr.includes(ids[k])) {
                        tempArr.splice(tempArr.indexOf(ids[k]), 1);
                      }
                    }
                  } else {
                    for (var k = 0; k < ids.length; k++) {
                      if (!tempArr.includes(ids[k])) {
                        tempArr.push(ids[k]);
                      }
                    }
                  }
                }
              }
            }
          }
          that.form.competitionGroupId = tempArr;
        }
      }
      var amount = 0;
      if (
        that.form.competitionGroupId != null &&
        that.form.competitionGroupId.length > 0
      ) {
        for (var i = 0; i < that.form.competitionGroupId.length; i++) {
          for (var j = 0; j < that.groupOptionList.length; j++) {
            if (
              that.form.competitionGroupId[i] == that.groupOptionList[j].value
            ) {
              if (that.groupOptionList[j].type === 1) {
                if (that.form.male != null && that.form.male != "") {
                  amount += that.groupOptionList[j].amount;
                }
                if (that.form.female != null && that.form.female != "") {
                  amount += that.groupOptionList[j].amount;
                }
              } else {
                amount += that.groupOptionList[j].amount;
              }
            }
          }
        }
      }
      that.form.entryFee = amount;
      that.lastSelected = [].concat(that.form.competitionGroupId);
    },
    calcEntryFeeGroup(item) {
      let that = this;
      var player = [];
      if (that.form.male != null && that.form.male.length > 0) {
        player = player.concat(this.form.male);
      }
      if (that.form.female != null && that.form.female.length > 0) {
        player = player.concat(that.form.female);
      }
      GroupApi.select({
        matchId: that.matchId,
        type: 2,
        playerIds: player.toString(),
      }).then((res) => {
        that.$nextTick(() => {
          that.groupOptionList = res.result;
          var amount = 0;
          if (
            that.form.competitionGroupId != null &&
            that.form.competitionGroupId.length > 0
          ) {
            for (var i = 0; i < that.form.competitionGroupId.length; i++) {
              for (var j = 0; j < that.groupOptionList.length; j++) {
                if (
                  that.form.competitionGroupId[i] ==
                  that.groupOptionList[j].value
                ) {
                  if (that.groupOptionList[j].type === 1) {
                    if (that.form.male != null && that.form.male.length > 0) {
                      amount +=
                        that.groupOptionList[j].amount * that.form.male.length;
                    }
                    if (that.form.female != null && that.form.female != "") {
                      amount +=
                        that.groupOptionList[j].amount *
                        that.form.female.length;
                    }
                  } else {
                    amount += that.groupOptionList[j].amount;
                  }
                }
              }
            }
          }
          that.form.entryFee = amount;
        });
      });
    },
    calcEntryFeeInputGroup(item) {
      let that = this;
      var player = [];
      if (that.formGroupInput.males != null && that.formGroupInput.males.length > 0) {
        player = player.concat(this.formGroupInput.males);
      }
      if (that.formGroupInput.females != null && that.formGroupInput.females.length > 0) {
        player = player.concat(that.formGroupInput.females);
      }
      GroupApi.selectInput({
        matchId: that.matchId,
        type: 2,
        playerIds: JSON.stringify(player),
      }).then((res) => {
        that.$nextTick(() => {
          that.groupOptionList = res.result;
          var amount = 0;
          if (
            that.formGroupInput.competitionGroupId != null &&
            that.formGroupInput.competitionGroupId.length > 0
          ) {
            for (var i = 0; i < that.formGroupInput.competitionGroupId.length; i++) {
              for (var j = 0; j < that.groupOptionList.length; j++) {
                if (
                  that.formGroupInput.competitionGroupId[i] ==
                  that.groupOptionList[j].value
                ) {
                  if (that.groupOptionList[j].type === 1) {
                    if (that.formGroupInput.males != null && that.formGroupInput.males.length > 0) {
                      amount +=
                        that.groupOptionList[j].amount * that.formGroupInput.males.length;
                    }
                    if (that.formGroupInput.females != null && that.formGroupInput.females != "") {
                      amount +=
                        that.groupOptionList[j].amount *
                        that.formGroupInput.females.length;
                    }
                  } else {
                    amount += that.groupOptionList[j].amount;
                  }
                }
              }
            }
          }
          that.formGroupInput.entryFee = amount;
        });
      });
    },
    calcEntryFeeTeam(item) {
      let that = this;
      var player = [];
      if (that.form.female != null && that.form.female.length > 0) {
        player = player.concat(this.form.female);
      }
      GroupApi.select({
        matchId: that.matchId,
        type: 3,
        playerIds: player.toString(),
      }).then((res) => {
        that.$nextTick(() => {
          that.groupOptionList = res.result;
          var amount = 0;
          var arr = new Array();
          if (
            that.form.competitionGroupId != null &&
            that.form.competitionGroupId.length > 0
          ) {
            for (var i = 0; i < that.form.competitionGroupId.length; i++) {
              for (var j = 0; j < that.groupOptionList.length; j++) {
                if (
                  that.form.competitionGroupId[i] ==
                  that.groupOptionList[j].value
                ) {
                  if (that.groupOptionList[j].type === 1) {
                    if (that.form.female != null && that.form.female != "") {
                      var isCalc = false;
                      for (
                        var k = 0;
                        k < that.teamRegistrationConfig.length;
                        k++
                      ) {
                        if (
                          (
                            "," +
                            that.teamRegistrationConfig[k].competitionGroupId +
                            ","
                          ).indexOf(
                            "," + that.groupOptionList[j].value + ","
                          ) != -1
                        ) {
                          if (
                            that.form.female.length >=
                            that.teamRegistrationConfig[k].startPeroid &&
                            that.form.female.length <=
                            that.teamRegistrationConfig[k].endPeroid
                          ) {
                            if (
                              that.teamRegistrationConfig[k].computeMode == 1
                            ) {
                              amount +=
                                that.teamRegistrationConfig[k].price *
                                that.form.female.length;
                              arr.push(
                                this.groupOptionList[j].code +
                                "(按人数计费):" +
                                that.teamRegistrationConfig[k].price +
                                "*" +
                                that.form.female.length
                              );
                            } else if (
                              that.teamRegistrationConfig[k].computeMode == 2
                            ) {
                              amount +=
                                that.teamRegistrationConfig[k].price *
                                that.teamRegistrationConfig[k].endPeroid;
                              arr.push(
                                that.groupOptionList[j].code +
                                "(按人数计费):" +
                                that.teamRegistrationConfig[k].price +
                                "*" +
                                that.teamRegistrationConfig[k].endPeroid
                              );
                            } else if (
                              that.teamRegistrationConfig[k].computeMode == 3
                            ) {
                              amount +=
                                that.teamRegistrationConfig[k].price *
                                that.teamRegistrationConfig[k].startPeroid;
                              arr.push(
                                that.groupOptionList[j].code +
                                "(按人数计费):" +
                                that.teamRegistrationConfig[k].price +
                                "*" +
                                that.teamRegistrationConfig[k].startPeroid
                              );
                            } else {
                              that.$message.error({
                                showClose: true,
                                message: "系统错误，配置不正确，请联系管理员！",
                                duration: 2000,
                              });
                            }
                            isCalc = true;
                          }
                        }
                      }
                      if (!isCalc) {
                        amount +=
                          that.groupOptionList[j].amount *
                          that.form.female.length;
                        arr.push(
                          that.groupOptionList[j].code +
                          "(按人数计费):" +
                          that.groupOptionList[j].amount +
                          "*" +
                          that.form.female.length
                        );
                      }
                    }
                  } else {
                    var isCalc = false;
                    for (
                      var k = 0;
                      k < that.teamRegistrationConfig.length;
                      k++
                    ) {
                      if (
                        (
                          "," +
                          that.teamRegistrationConfig[k].competitionGroupId +
                          ","
                        ).indexOf("," + that.groupOptionList[j].value + ",") !=
                        -1
                      ) {
                        if (
                          that.form.female.length >=
                          that.teamRegistrationConfig[k].startPeroid &&
                          that.form.female.length <=
                          that.teamRegistrationConfig[k].endPeroid
                        ) {
                          amount += that.teamRegistrationConfig[k].price;
                          isCalc = true;
                          arr.push(
                            that.groupOptionList[j].code +
                            "(按组别计费):" +
                            that.teamRegistrationConfig[k].price +
                            "*" +
                            this.form.female.length
                          );
                        }
                      }
                    }
                    if (!isCalc) {
                      amount += that.groupOptionList[j].amount;
                      arr.push(
                        that.groupOptionList[j].code +
                        "(按组别计费):" +
                        that.groupOptionList[j].amount +
                        "*" +
                        that.form.female.length
                      );
                    }
                  }
                }
              }
            }
          }
          that.calcTeamMessage = arr.join();
          that.form.entryFee = amount;
        });
      });
    },
    calcEntryFeeInputTeam(item) {
      let that = this;
      var player = [];
      if (that.formTeamInput.females != null && that.formTeamInput.females.length > 0) {
        player = player.concat(that.formTeamInput.females);
      }
      GroupApi.selectInput({
        matchId: that.matchId,
        type: 3,
        playerIds: JSON.stringify(player),
      }).then((res) => {
        that.$nextTick(() => {
          that.groupOptionList = res.result;
          var amount = 0;
          var arr = new Array();
          if (that.formTeamInput.competitionGroupId != null && that.formTeamInput.competitionGroupId.length > 0) {
            for (var i = 0; i < that.formTeamInput.competitionGroupId.length; i++) {
              for (var j = 0; j < that.groupOptionList.length; j++) {
                if (that.formTeamInput.competitionGroupId[i] == that.groupOptionList[j].value) {
                  if (that.groupOptionList[j].type === 1) {
                    if (that.formTeamInput.females != null && that.formTeamInput.females.length > 0) {
                      var isCalc = false;
                      for (
                        var k = 0;
                        k < that.teamRegistrationConfig.length;
                        k++
                      ) {
                        if (
                          (
                            "," +
                            that.teamRegistrationConfig[k].competitionGroupId +
                            ","
                          ).indexOf(
                            "," + that.groupOptionList[j].value + ","
                          ) != -1
                        ) {
                          if (
                            that.formTeamInput.females.length >=
                            that.teamRegistrationConfig[k].startPeroid &&
                            that.formTeamInput.females.length <=
                            that.teamRegistrationConfig[k].endPeroid
                          ) {
                            if (
                              that.teamRegistrationConfig[k].computeMode == 1
                            ) {
                              amount +=
                                that.teamRegistrationConfig[k].price *
                                that.formTeamInput.females.length;
                              arr.push(
                                this.groupOptionList[j].code +
                                "(按人数计费):" +
                                that.teamRegistrationConfig[k].price +
                                "*" +
                                that.formTeamInput.females.length
                              );
                            } else if (
                              that.teamRegistrationConfig[k].computeMode == 2
                            ) {
                              amount +=
                                that.teamRegistrationConfig[k].price *
                                that.teamRegistrationConfig[k].endPeroid;
                              arr.push(
                                that.groupOptionList[j].code +
                                "(按人数计费):" +
                                that.teamRegistrationConfig[k].price +
                                "*" +
                                that.teamRegistrationConfig[k].endPeroid
                              );
                            } else if (
                              that.teamRegistrationConfig[k].computeMode == 3
                            ) {
                              amount +=
                                that.teamRegistrationConfig[k].price *
                                that.teamRegistrationConfig[k].startPeroid;
                              arr.push(
                                that.groupOptionList[j].code +
                                "(按人数计费):" +
                                that.teamRegistrationConfig[k].price +
                                "*" +
                                that.teamRegistrationConfig[k].startPeroid
                              );
                            } else {
                              that.$message.error({ showClose: true, message: "系统错误，配置不正确，请联系管理员！", duration: 2000 });
                            }
                            isCalc = true;
                          }
                        }
                      }
                      if (!isCalc) {
                        amount +=
                          that.groupOptionList[j].amount *
                          that.formTeamInput.females.length;
                        arr.push(
                          that.groupOptionList[j].code +
                          "(按人数计费):" +
                          that.groupOptionList[j].amount +
                          "*" +
                          that.formTeamInput.females.length
                        );
                      }
                    }
                  } else {
                    var isCalc = false;
                    for (
                      var k = 0;
                      k < that.teamRegistrationConfig.length;
                      k++
                    ) {
                      if (
                        (
                          "," +
                          that.teamRegistrationConfig[k].competitionGroupId +
                          ","
                        ).indexOf("," + that.groupOptionList[j].value + ",") !=
                        -1
                      ) {
                        if (
                          that.formTeamInput.females.length >=
                          that.teamRegistrationConfig[k].startPeroid &&
                          that.formTeamInput.females.length <=
                          that.teamRegistrationConfig[k].endPeroid
                        ) {
                          amount += that.teamRegistrationConfig[k].price;
                          isCalc = true;
                          arr.push(
                            that.groupOptionList[j].code +
                            "(按组别计费):" +
                            that.teamRegistrationConfig[k].price +
                            "*" +
                            that.formTeamInput.females.length
                          );
                        }
                      }
                    }
                    if (!isCalc) {
                      amount += that.groupOptionList[j].amount;
                      arr.push(
                        that.groupOptionList[j].code +
                        "(按组别计费):" +
                        that.groupOptionList[j].amount +
                        "*" +
                        that.formTeamInput.females.length
                      );
                    }
                  }
                }
              }
            }
          }
          that.calcTeamMessage = arr.join();
          that.formTeamInput.entryFee = amount;
        });
      });
    },
    handleCommand(command) {
      this.isLoading = false;
      switch (command) {
        case "addPlayer":
          this.addPlayer();
          break;
        case "addgroup":
          this.addGroupPlayer();
          break;
        case "addteam":
          this.addTeamPlayer();
          break;
        default:
          break;
      }
    },
    editPlayer(row) {
      API.get({ id: row.id }).then((result) => {
        this.isLoading = false;
        if (row.type == 1) {
          this.dialogSingleFormVisible = true;
        } else if (row.type == 2) {
          this.dialogGroupFormVisible = true;
        } else if (row.type == 3) {
          this.dialogTeamFormVisible = true;
        }
        if (sessionStorage.getItem("userType") == "1") {
          PlayerApi.adminSelect({ teamId: result.result.teamId }).then(
            (res) => {
              this.playerList = res.result;
            }
          );
        }
        var data = result.result;
        this.form.id = data.id;
        var players = [];
        if (data.type == 1) {
          this.singleDialogModel = '选择录入';
          this.form.male = data.male;
          this.form.female = data.female;
          if (data.male != null && data.male != '') {
            players.push(data.male);
          }
          if (data.female != null && data.female != '') {
            players.push(data.female);
          }
        } else if (data.type == 2) {
          this.groupDialogModel = '选择录入';
          this.form.male = data.male.split(",");
          this.form.female = data.female.split(",");
          if (data.male != null && data.male != '') {
            players.push(this.form.male);
          }
          if (data.female != null && data.female != '') {
            players.push(this.form.female);
          }
        } else if (data.type == 3) {
          this.teamDialogModel = '选择录入';
          this.form.male = data.male;
          this.form.female = data.female.split(",");
          players.push(this.form.female);
        }
        GroupApi.select({ matchId: this.matchId, type: row.type, playerIds: players.toString() }).then((res) => {
          this.groupOptionList = res.result;
        });
        this.form.competitionGroupId = [data.competitionGroupId.toString()];
        this.form.teamId = data.teamId.toString();
        this.form.entryFee = data.entryFee;
        this.form.type = data.type;
        this.form.matchId = data.matchId;
        //this.form = Object.assign({}, result.result)
      });
    },
    addPlayer() {
      GroupApi.select({ matchId: this.matchId, type: 1 }).then((res) => {
        this.groupOptionList = res.result;
      });
      this.form.id = 0;
      this.form.entryFee = 0;
      this.form.type = 1;
      this.form.male = null;
      this.isSingleGroup = false;
      this.form.female = null;
      this.form.competitionGroupId = null;
      this.form.matchId = this.matchId;
      this.lastSelected = null;
      this.dialogSingleFormVisible = true;
      this.formSingleInput = { id: 0, maleid: 0, teamId: null, malename: '', maleidentityNo: '', femaleid: 0, femalename: '', femaleidentityNo: '', competitionGroupId: null, entryFee: "", type: 1, }
      if (sessionStorage.getItem("userType") != "1") {
        this.formSingleInput.teamId = this.teamOptions[0].value;
      }
      this.singleDialogModel = '手动输入';
    },
    //6-12人组
    addGroupPlayer() {
      GroupApi.select({ matchId: this.matchId, type: 2 }).then((res) => { this.groupOptionList = res.result; });
      this.form.id = 0;
      this.form.entryFee = 0;
      this.form.type = 2;
      this.form.competitionGroupId = [];
      this.form.male = [];
      this.form.female = [];
      this.form.teamId = null;
      this.form.matchId = this.matchId;
      this.lastSelected = null;
      this.dialogGroupFormVisible = true;
      this.formGroupInput = {
        id: 0, teamId: null, males: [{ id: 0, name: '', identityNo: '' }, { id: 0, name: '', identityNo: '' }, { id: 0, name: '', identityNo: '' }], females: [{ id: 0, name: '', identityNo: '' }, { id: 0, name: '', identityNo: '' }, { id: 0, name: '', identityNo: '' }],
        competitionGroupId: null, entryFee: "", type: 2
      };
      this.groupDialogModel = '手动输入';
      if (sessionStorage.getItem("userType") != "1") {
        this.formGroupInput.teamId = this.teamOptions[0].value;
      }
    },
    //团体舞
    addTeamPlayer() {
      GroupApi.select({ matchId: this.matchId, type: 3 }).then((res) => {
        this.groupOptionList = res.result;
      });
      this.form.id = 0;
      this.form.type = 3;
      this.form.competitionGroupId = null;
      this.form.matchId = this.matchId;
      this.form.male = null;
      this.form.female = [];
      this.form.entryFee = 0;
      this.lastSelected = null;
      this.dialogTeamFormVisible = true;
      this.formTeamInput = { id: 0, teamId: null, male: '', females: [{ id: 0, name: '', identityNo: '' }], competitionGroupId: null, entryFee: "", type: 3 };
      if (sessionStorage.getItem("userType") != "1") {
        this.formTeamInput.teamId = this.teamOptions[0].value;
      }
      this.teamDialogModel = '手动输入';
    },
    addTeamPlayerInput() {
      this.formTeamInput.females.push({ id: 0, name: '', identityNo: '' });
    },
    deleteTeamPlayerInput(index) {
      this.formTeamInput.females.splice(index, 1);
      this.calcEntryFeeInputTeam();
    },
    addGroupMalePlayerInput() {
      this.formGroupInput.males.push({ id: 0, name: '', identityNo: '' });
    },
    deleteGroupMalePlayerInput(index) {
      this.formGroupInput.males.splice(index, 1);
      this.calcEntryFeeInputGroup();
    },
    addGroupFemalePlayerInput() {
      this.formGroupInput.females.push({ id: 0, name: '', identityNo: '' });
    },
    deleteGroupFemalePlayerInput(index) {
      this.formGroupInput.females.splice(index, 1);
      this.calcEntryFeeInputGroup();
    },
    handleSizeChange: function (val) {
      this.searchForm.pageSize = val;
      this.search();
    },
    handleCurrentChange: function (val) {
      this.searchForm.page = val;
      this.search();
    },
    searchdata() {
      this.searchForm.page = 1;
      this.search();
    },
    search: function () {
      let params = Object.assign({}, this.searchForm);
      API.getList(params)
        .then((result) => {
          if (result && result.code == 0) {
            this.tableListData = result.result.data;
            this.total = result.result.recordCount;
          } else {
            this.$message.error({
              showClose: true,
              message: result.result.message,
              duration: 2000,
            });
          }
        })
        .catch((error) => {
          this.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000,
          });
        });
      API.total({ matchId: this.matchId }).then((res) => {
        if (res != null && res.code == 0) {
          if (res.result.total) {
            this.totalAmount = res.result.total;
          }
          if (res.result.rebate) {
            this.rebeateAmount = res.result.rebate;
          }
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    submitFormSingle() {
      let that = this;
      this.isLoading = true;
      if (this.singleDialogModel == "选择录入") {
        this.$refs.formsingle.validate((valid) => {
          if (valid) {
            let params = Object.assign({}, this.form);
            if (params.male instanceof Array) {
              params.male = params.male.join(",");
            }
            if (params.female instanceof Array) {
              params.female = params.female.join(",");
            }
            if (params.id > 0) {
              if (sessionStorage.getItem("userType") == "1") {
                API.adminEdit(params)
                  .then(
                    (data) => {
                      if (data.code == 0) {
                        that.$message.success({
                          showClose: true,
                          message: "更改成功",
                          duration: 2000,
                        });
                        that.dialogSingleFormVisible = false;
                        that.$refs["formsingle"].resetFields();
                        that.search();
                      } else {
                        this.$alert(data.message, "提示", {
                          confirmButtonText: "确定",
                        });
                      }
                      that.isLoading = false;
                    },
                    function (err) {
                      that.$message.error({
                        showClose: true,
                        message: err.toString(),
                        duration: 2000,
                      });
                      that.isLoading = false;
                    }
                  )
                  .catch(function (error) {
                    that.$message.error({
                      showClose: true,
                      message: "请求出现异常",
                      duration: 2000,
                    });
                    that.isLoading = false;
                  });
              } else {
                API.edit(params)
                  .then(
                    (data) => {
                      if (data.code == 0) {
                        that.$message.success({
                          showClose: true,
                          message: "更改成功",
                          duration: 2000,
                        });
                        that.dialogSingleFormVisible = false;
                        that.$refs["formsingle"].resetFields();
                        that.search();
                      } else {
                        this.$alert(data.message, "提示", {
                          confirmButtonText: "确定",
                        });
                      }
                      that.isLoading = false;
                    },
                    function (err) {
                      that.$message.error({
                        showClose: true,
                        message: err.toString(),
                        duration: 2000,
                      });
                      that.isLoading = false;
                    }
                  )
                  .catch(function (error) {
                    that.$message.error({
                      showClose: true,
                      message: "请求出现异常",
                      duration: 2000,
                    });
                    that.isLoading = false;
                  });
              }
            } else {
              if (sessionStorage.getItem("userType") == "1") {
                API.adminAdd(params)
                  .then((result) => {
                    if (result.code == 0) {
                      this.$message.success({
                        showClose: true,
                        message: "报名成功",
                        duration: 2000,
                      });
                      this.$refs["formsingle"].resetFields();
                      this.dialogSingleFormVisible = false;
                      this.search();
                      this.isLoading = false;
                    } else {
                      this.$alert(result.message, "提示", {
                        confirmButtonText: "确定",
                      });
                      this.isLoading = false;
                    }
                  })
                  .catch((error) => {
                    this.$message.error({
                      showClose: true,
                      message: "请求异常",
                      duration: 2000,
                    });
                    this.isLoading = false;
                  });
              } else {
                API.add(params)
                  .then((result) => {
                    if (result.code == 0) {
                      this.$message.success({
                        showClose: true,
                        message: "报名成功",
                        duration: 2000,
                      });
                      this.$refs["formsingle"].resetFields();
                      this.dialogSingleFormVisible = false;
                      this.search();
                      this.isLoading = false;
                    } else {
                      this.$alert(result.message, "提示", {
                        confirmButtonText: "确定",
                      });
                      this.isLoading = false;
                    }
                  })
                  .catch((error) => {
                    this.$message.error({
                      showClose: true,
                      message: "请求异常",
                      duration: 2000,
                    });
                    this.isLoading = false;
                  });
              }
            }
          } else {
            this.isLoading = false;
          }
        });
      }
      else {
        this.$refs.formSingleInput.validate((valid) => {
          if (valid) {
            if (this.isNeedIdentity && (this.formSingleInput.maleidentityNo == null || this.formSingleInput.maleidentityNo == '')) {
              this.$message.error({ showClose: true, message: "请输入男步身份证号", duration: 2000 });
              this.isLoading = false;
              return;
            }
            if (this.formSingleInput.femalename != null && this.formSingleInput.femalename != '') {
              if (this.isNeedIdentity && (this.formSingleInput.femaleidentityNo == null || this.formSingleInput.femaleidentityNo == '')) {
                this.$message.error({ showClose: true, message: "请输入女步身份证号", duration: 2000 });
                this.isLoading = false;
                return;
              }
            }
            var male = this.formSingleInput.maleid + '|' + this.formSingleInput.malename + '|' + this.formSingleInput.maleidentityNo;
            var female = this.formSingleInput.femaleid + '|' + this.formSingleInput.femalename + '|' + this.formSingleInput.femaleidentityNo;
            var data = {
              id: this.formSingleInput.id,
              male: male,
              teamId: this.formSingleInput.teamId,
              female: female,
              competitionGroupId: this.formSingleInput.competitionGroupId,
              matchId: this.matchId,
              entryFee: this.formSingleInput.entryFee,
              type: 1
            }
            if (data.id > 0) {
              API.editSimple(data)
                .then(
                  (data) => {
                    if (data.code == 0) {
                      that.$message.success({
                        showClose: true,
                        message: "更改成功",
                        duration: 2000,
                      });
                      that.dialogSingleFormVisible = false;
                      that.$refs["formsingle"].resetFields();
                      that.search();
                    } else {
                      this.$alert(data.message, "提示", {
                        confirmButtonText: "确定",
                      });
                    }
                    that.isLoading = false;
                  },
                  function (err) {
                    that.$message.error({
                      showClose: true,
                      message: err.toString(),
                      duration: 2000,
                    });
                    that.isLoading = false;
                  }
                )
                .catch(function (error) {
                  that.$message.error({
                    showClose: true,
                    message: "请求出现异常",
                    duration: 2000,
                  });
                  that.isLoading = false;
                });
            } else {
              API.addSimple(data)
                .then((result) => {
                  if (result.code == 0) {
                    this.$message.success({
                      showClose: true,
                      message: "报名成功",
                      duration: 2000,
                    });
                    this.$refs["formSingleInput"].resetFields();
                    this.dialogSingleFormVisible = false;
                    this.search();
                    this.isLoading = false;
                  } else {
                    this.$alert(result.message, "提示", {
                      confirmButtonText: "确定",
                    });
                    this.isLoading = false;
                  }
                })
                .catch((error) => {
                  this.$message.error({
                    showClose: true,
                    message: "请求异常",
                    duration: 2000,
                  });
                  this.isLoading = false;
                });
            }
          }
          else {
            this.isLoading = false;
          }
        });
      }
    },
    submitFormGroup() {
      let that = this;
      this.isLoading = true;
      if (this.groupDialogModel == "选择录入") {
        this.$refs.formGroupSelect.validate((valid) => {
          if (valid) {
            let params = Object.assign({}, this.form);
            if (params.male instanceof Array) {
              params.male = params.male.join(",");
            }
            if (params.female instanceof Array) {
              params.female = params.female.join(",");
            }
            if (params.id > 0) {
              if (sessionStorage.getItem("userType") == "1") {
                API.adminEdit(params)
                  .then(
                    (data) => {
                      if (data.code == 0) {
                        that.$message.success({
                          showClose: true,
                          message: "更改成功",
                          duration: 2000,
                        });
                        that.dialogGroupFormVisible = false;
                        that.$refs["formGroupSelect"].resetFields();
                        that.search();
                      } else {
                        this.$alert(data.message, "提示", {
                          confirmButtonText: "确定",
                        });
                      }
                      that.isLoading = false;
                    },
                    function (err) {
                      that.$message.error({
                        showClose: true,
                        message: err.toString(),
                        duration: 2000,
                      });
                      that.isLoading = false;
                    }
                  )
                  .catch(function (error) {
                    that.$message.error({
                      showClose: true,
                      message: "请求出现异常",
                      duration: 2000,
                    });
                    that.isLoading = false;
                  });
              } else {
                API.edit(params)
                  .then(
                    (data) => {
                      if (data.code == 0) {
                        that.$message.success({
                          showClose: true,
                          message: "更改成功",
                          duration: 2000,
                        });
                        that.dialogGroupFormVisible = false;
                        that.$refs["formGroupSelect"].resetFields();
                        that.search();
                      } else {
                        this.$alert(data.message, "提示", {
                          confirmButtonText: "确定",
                        });
                      }
                      that.isLoading = false;
                    },
                    function (err) {
                      that.$message.error({
                        showClose: true,
                        message: err.toString(),
                        duration: 2000,
                      });
                      that.isLoading = false;
                    }
                  )
                  .catch(function (error) {
                    that.$message.error({
                      showClose: true,
                      message: "请求出现异常",
                      duration: 2000,
                    });
                    that.isLoading = false;
                  });
              }
            } else {
              if (sessionStorage.getItem("userType") == "1") {
                API.adminAdd(params)
                  .then((result) => {
                    if (result.code == 0) {
                      this.$message.success({
                        showClose: true,
                        message: "报名成功",
                        duration: 2000,
                      });
                      this.$refs["formGroupSelect"].resetFields();
                      this.dialogGroupFormVisible = false;
                      this.search();
                      this.isLoading = false;
                    } else {
                      this.$alert(result.message, "提示", {
                        confirmButtonText: "确定",
                      });
                      this.isLoading = false;
                    }
                  })
                  .catch((error) => {
                    this.$message.error({
                      showClose: true,
                      message: "请求异常",
                      duration: 2000,
                    });
                    this.isLoading = false;
                  });
              } else {
                API.add(params)
                  .then((result) => {
                    if (result.code == 0) {
                      this.$message.success({
                        showClose: true,
                        message: "报名成功",
                        duration: 2000,
                      });
                      this.$refs["formGroupSelect"].resetFields();
                      this.dialogGroupFormVisible = false;
                      this.search();
                      this.isLoading = false;
                    } else {
                      this.$alert(result.message, "提示", {
                        confirmButtonText: "确定",
                      });
                      this.isLoading = false;
                    }
                  })
                  .catch((error) => {
                    this.$message.error({
                      showClose: true,
                      message: "请求异常",
                      duration: 2000,
                    });
                    this.isLoading = false;
                  });
              }
            }
          } else {
            this.isLoading = false;
          }
        });
      }
      else {
        this.$refs.formGroupInputRef.validate((valid) => {
          if (valid) {
            var arraymale = [];
            this.formGroupInput.males.forEach(item => {
              if (item.name != null && item.name != '') {
                if (this.isNeedIdentity && (item.identityNo == null || item.identityNo == '')) {
                  this.$message.error({ showClose: true, message: "请输入身份证号", duration: 2000 });
                  this.isLoading = false;
                  return;
                }
                arraymale.push(item.id + '|' + item.name + '|' + item.identityNo)
              }
            });
            var arrayfemale = [];
            this.formGroupInput.females.forEach(item => {
              if (item.name != null && item.name != '') {
                if (this.isNeedIdentity && (item.identityNo == null || item.identityNo == '')) {
                  this.$message.error({ showClose: true, message: "请输入身份证号", duration: 2000 });
                  this.isLoading = false;
                  return;
                }
                arrayfemale.push(item.id + '|' + item.name + '|' + item.identityNo)
              }
            });
            if (arraymale.length < 1) {
              this.$message.error({ showClose: true, message: "请输入选手1（男步）", duration: 2000 });
              this.isLoading = false;
              return;
            } 
            /*if (arrayfemale.length < 1) {
              this.$message.error({ showClose: true, message: "请输入选手2（女步）", duration: 2000 });
              this.isLoading = false;
              return;
            }*/
            var data = {
              id: this.formGroupInput.id,
              male: arraymale.toString(),
              teamId: this.formGroupInput.teamId,
              female: arrayfemale.toString(),
              competitionGroupId: this.formGroupInput.competitionGroupId,
              matchId: this.matchId,
              entryFee: this.formGroupInput.entryFee,
              type: 2
            }
            if (data.id > 0) {
              API.edit(data)
                .then(
                  (data) => {
                    if (data.code == 0) {
                      that.$message.success({
                        showClose: true,
                        message: "更改成功",
                        duration: 2000,
                      });
                      that.dialogGroupFormVisible = false;
                      that.search();
                    } else {
                      this.$alert(data.message, "提示", {
                        confirmButtonText: "确定",
                      });
                    }
                    that.isLoading = false;
                  },
                  function (err) {
                    that.$message.error({
                      showClose: true,
                      message: err.toString(),
                      duration: 2000,
                    });
                    that.isLoading = false;
                  }
                )
                .catch(function (error) {
                  that.$message.error({
                    showClose: true,
                    message: "请求出现异常",
                    duration: 2000,
                  });
                  that.isLoading = false;
                });
            } else {
              API.addSimple(data)
                .then((result) => {
                  if (result.code == 0) {
                    this.$message.success({
                      showClose: true,
                      message: "报名成功",
                      duration: 2000,
                    });
                    this.$refs["formGroupInputRef"].resetFields();
                    this.dialogGroupFormVisible = false;
                    this.search();
                    this.isLoading = false;
                  } else {
                    this.$alert(result.message, "提示", {
                      confirmButtonText: "确定",
                    });
                    this.isLoading = false;
                  }
                })
                .catch((error) => {
                  this.$message.error({
                    showClose: true,
                    message: "请求异常",
                    duration: 2000,
                  });
                  this.isLoading = false;
                });
            }
          } else {
            this.isLoading = false;
          }
        });
      }
    },
    submitFormTeam() {
      let that = this;
      this.isLoading = true;
      if (this.teamDialogModel == "选择录入") {
        this.$refs.formteam.validate((valid) => {
          if (valid) {
            let params = Object.assign({}, this.form);
            if (params.male instanceof Array) {
              params.male = params.male.join(",");
            }
            if (params.female instanceof Array) {
              params.female = params.female.join(",");
            }
            if (params.id > 0) {
              if (sessionStorage.getItem("userType") == "1") {
                API.adminEdit(params)
                  .then(
                    (data) => {
                      if (data.code == 0) {
                        that.$message.success({
                          showClose: true,
                          message: "更改成功",
                          duration: 2000,
                        });
                        that.dialogTeamFormVisible = false;
                        that.$refs["formteam"].resetFields();
                        that.search();
                      } else {
                        this.$alert(data.message, "提示", {
                          confirmButtonText: "确定",
                        });
                      }
                      that.isLoading = false;
                    },
                    function (err) {
                      that.$message.error({
                        showClose: true,
                        message: err.toString(),
                        duration: 2000,
                      });
                      that.isLoading = false;
                    }
                  )
                  .catch(function (error) {
                    that.$message.error({
                      showClose: true,
                      message: "请求出现异常",
                      duration: 2000,
                    });
                    that.isLoading = false;
                  });
              } else {
                API.edit(params)
                  .then(
                    (data) => {
                      if (data.code == 0) {
                        that.$message.success({
                          showClose: true,
                          message: "更改成功",
                          duration: 2000,
                        });
                        that.dialogTeamFormVisible = false;
                        that.$refs["formteam"].resetFields();
                        that.search();
                      } else {
                        this.$alert(data.message, "提示", {
                          confirmButtonText: "确定",
                        });
                      }
                      that.isLoading = false;
                    },
                    function (err) {
                      that.$message.error({
                        showClose: true,
                        message: err.toString(),
                        duration: 2000,
                      });
                      that.isLoading = false;
                    }
                  )
                  .catch(function (error) {
                    that.$message.error({
                      showClose: true,
                      message: "请求出现异常",
                      duration: 2000,
                    });
                    that.isLoading = false;
                  });
              }
            } else {
              if (sessionStorage.getItem("userType") == "1") {
                API.adminAdd(params)
                  .then((result) => {
                    if (result.code == 0) {
                      this.$message.success({
                        showClose: true,
                        message: "报名成功",
                        duration: 2000,
                      });
                      this.$refs["formteam"].resetFields();
                      this.dialogTeamFormVisible = false;
                      this.search();
                      this.isLoading = false;
                    } else {
                      this.$alert(result.message, "提示", {
                        confirmButtonText: "确定",
                      });
                      this.isLoading = false;
                    }
                  })
                  .catch((error) => {
                    this.$message.error({
                      showClose: true,
                      message: "请求异常",
                      duration: 2000,
                    });
                    this.isLoading = false;
                  });
              } else {
                API.add(params)
                  .then((result) => {
                    if (result.code == 0) {
                      this.$message.success({
                        showClose: true,
                        message: "报名成功",
                        duration: 2000,
                      });
                      this.$refs["formteam"].resetFields();
                      this.dialogTeamFormVisible = false;
                      this.search();
                      this.isLoading = false;
                    } else {
                      this.$alert(result.message, "提示", {
                        confirmButtonText: "确定",
                      });
                      this.isLoading = false;
                    }
                  })
                  .catch((error) => {
                    this.$message.error({
                      showClose: true,
                      message: "请求异常",
                      duration: 2000,
                    });
                    this.isLoading = false;
                  });
              }
            }
          } else {
            this.isLoading = false;
          }
        });
      } else {
        this.$refs.formTeamInput.validate((valid) => {
          if (valid) {
            var arrayfemale = [];
            this.formTeamInput.females.forEach(item => {
              if (item.name != null && item.name != '') {
                if (this.isNeedIdentity && (item.identityNo == null || item.identityNo == '')) {
                  this.$message.error({ showClose: true, message: "请输入身份证号", duration: 2000 });
                  this.isLoading = false;
                  return;
                }
                arrayfemale.push(item.id + '|' + item.name + '|' + item.identityNo)
              }
            });
            if (arrayfemale.length < 1) {
              this.$message.error({ showClose: true, message: "请输入选手", duration: 2000 });
              this.isLoading = false;
              return;
            }
            var data = {
              id: this.formTeamInput.id,
              male: this.formTeamInput.male,
              teamId: this.formTeamInput.teamId,
              female: arrayfemale.toString(),
              competitionGroupId: this.formTeamInput.competitionGroupId,
              matchId: this.matchId,
              entryFee: this.formTeamInput.entryFee,
              type: 3
            }
            if (data.id > 0) {
              API.edit(data)
                .then(
                  (data) => {
                    if (data.code == 0) {
                      that.$message.success({
                        showClose: true,
                        message: "更改成功",
                        duration: 2000,
                      });
                      that.dialogTeamFormVisible = false;
                      that.$refs["formteam"].resetFields();
                      that.search();
                    } else {
                      this.$alert(data.message, "提示", {
                        confirmButtonText: "确定",
                      });
                    }
                    that.isLoading = false;
                  },
                  function (err) {
                    that.$message.error({
                      showClose: true,
                      message: err.toString(),
                      duration: 2000,
                    });
                    that.isLoading = false;
                  }
                )
                .catch(function (error) {
                  that.$message.error({
                    showClose: true,
                    message: "请求出现异常",
                    duration: 2000,
                  });
                  that.isLoading = false;
                });
            } else {
              API.addSimple(data)
                .then((result) => {
                  if (result.code == 0) {
                    this.$message.success({
                      showClose: true,
                      message: "报名成功",
                      duration: 2000,
                    });
                    this.$refs["formTeamInput"].resetFields();
                    this.dialogTeamFormVisible = false;
                    this.search();
                    this.isLoading = false;
                  } else {
                    this.$alert(result.message, "提示", {
                      confirmButtonText: "确定",
                    });
                    this.isLoading = false;
                  }
                })
                .catch((error) => {
                  this.$message.error({
                    showClose: true,
                    message: "请求异常",
                    duration: 2000,
                  });
                  this.isLoading = false;
                });
            }
          } else {
            this.isLoading = false;
          }
        });
      }
    },
    deletePlayer(row) {
      let params = { id: row.id };
      if (row.isRelated == true) {
        this.$confirm("有兼报组别是否关联删除？", "提示", { type: "warning" })
          .then(() => {
            API.delete(params)
              .then((result) => {
                if (result.code == 0) {
                  this.$message.success({
                    showClose: true,
                    message: "删除成功",
                    duration: 2000,
                  });
                  this.search();
                } else {
                  this.$message.error({
                    showClose: true,
                    message: "系统错误",
                    duration: 2000,
                  });
                }
              })
              .catch((error) => {
                this.$message.error({
                  showClose: true,
                  message: "123",
                  duration: 2000,
                });
              });
          })
          .catch(() => { });
      } else {
        this.$confirm("确认删除选手吗？", "提示", { type: "warning" })
          .then(() => {
            API.delete(params)
              .then((result) => {
                if (result.code == 0) {
                  this.$message.success({
                    showClose: true,
                    message: "删除成功",
                    duration: 2000,
                  });
                  this.search();
                } else {
                  this.$message.error({
                    showClose: true,
                    message: "系统错误",
                    duration: 2000,
                  });
                }
              })
              .catch((error) => {
                this.$message.error({
                  showClose: true,
                  message: "123",
                  duration: 2000,
                });
              });
          })
          .catch(() => { });
      }
    },
    /*批量删除*/
    delMulData() {
      let that = this;
      let val = that.multipleSelection;
      let idArray = [];
      for (var i = 0; i < val.length; i++) {
        idArray.push(val[i].id);
      }
      var items = this.tableListData.filter((item) => {
        if (item.isRelated == true) {
          return item;
        }
      });
      if (items.length > 0) {
        this.$confirm("有兼报组别是否关联删除", "提示", {
          confimButtonTexe: "确定",
          cancelButtonTexe: "取消",
          type: "warning",
        }).then(() => {
          if (idArray) {
            API.deleteBatch({ ids: idArray.join() })
              .then(
                function (result) {
                  that.loading = false;
                  if (result && result.code == 0) {
                    that.$message.success({
                      showClose: true,
                      message: "删除成功",
                      duration: 2000,
                    });
                    that.search();
                  } else {
                    that.$message.error({
                      showClose: true,
                      message: "删除操作异常，请重试",
                      duration: 2000,
                    });
                  }
                },
                function (err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000,
                  });
                }
              )
              .catch(function (error) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000,
                });
              });
          }
        });
      } else {
        this.$confirm("此操作将永久删除该数据，是否继续？", "提示", {
          confimButtonTexe: "确定",
          cancelButtonTexe: "取消",
          type: "warning",
        }).then(() => {
          if (idArray) {
            API.deleteBatch({ ids: idArray.join() })
              .then(
                function (result) {
                  that.loading = false;
                  if (result && result.code == 0) {
                    that.$message.success({
                      showClose: true,
                      message: "删除成功",
                      duration: 2000,
                    });
                    that.search();
                  } else {
                    that.$message.error({
                      showClose: true,
                      message: "删除操作异常，请重试",
                      duration: 2000,
                    });
                  }
                },
                function (err) {
                  that.loading = false;
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000,
                  });
                }
              )
              .catch(function (error) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000,
                });
              });
          }
        });
      }
      this.$refs.multipleTable.clearSelection();
    },
    approve() {
      let that = this;
      let val = that.multipleSelection;
      let idArray = [];
      for (var i = 0; i < val.length; i++) {
        idArray.push(val[i].id);
      }
      this.$confirm("此操作将审核通过已选择选手，是否继续？", "提示", {
        confimButtonTexe: "确定",
        cancelButtonTexe: "取消",
        type: "warning",
      }).then(() => {
        if (idArray) {
          API.approve({ ids: idArray.join() })
            .then(
              function (result) {
                that.loading = false;
                if (result && result.code == 0) {
                  that.$message.success({
                    showClose: true,
                    message: "审核成功",
                    duration: 2000,
                  });
                  that.search();
                } else {
                  that.$message.error({
                    showClose: true,
                    message: "操作异常，请重试",
                    duration: 2000,
                  });
                }
              },
              function (err) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000,
                });
              }
            )
            .catch(function (error) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000,
              });
            });
        }
      });
      this.$refs.multipleTable.clearSelection();
    },
    cancelApprove() {
      let that = this;
      let val = that.multipleSelection;
      let idArray = [];
      for (var i = 0; i < val.length; i++) {
        idArray.push(val[i].id);
      }
      this.$confirm("此操作将取消审核已选择选手，是否继续？", "提示", {
        confimButtonTexe: "确定",
        cancelButtonTexe: "取消",
        type: "warning",
      }).then(() => {
        if (idArray) {
          API.cancelApprove({ ids: idArray.join() })
            .then(
              function (result) {
                that.loading = false;
                if (result && result.code == 0) {
                  that.$message.success({
                    showClose: true,
                    message: "取消审核成功",
                    duration: 2000,
                  });
                  that.search();
                } else {
                  that.$message.error({
                    showClose: true,
                    message: "操作异常，请重试",
                    duration: 2000,
                  });
                }
              },
              function (err) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000,
                });
              }
            )
            .catch(function (error) {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000,
              });
            });
        }
      });
      this.$refs.multipleTable.clearSelection();
    },
    loadTeamPlayer(query) {
      PlayerApi.adminSelect({ teamId: query }).then((res) => {
        this.playerList = res.result;
      });
    },
    loadPlayerList() {
      PlayerApi.select({matchId:this.matchId}).then((res) => {
        this.playerList = res.result;
      });
    }
  },
  computed: {},
  mounted() {
    MAPI.get({ id: this.matchId }).then((res) => {
      this.isShowRebate = res.result.isShowTeamRebate;
      this.isNeedIdentity = res.result.isNeedIdentity;
      if( sessionStorage.getItem('uid')==='2077')
      {
        this.isShowRebate=false;
      }
      this.exportMode=res.result.exportMode;
    });

    this.searchdata();
    TM.select({ matchId: this.matchId }).then((res) => {
      this.teamOptions = res.result;
    });
    TM.getAllTeams({ matchId: this.matchId }).then((res) => {
      this.teamListOptions = res.result;
    });
    this.loadPlayerList();
    GroupApi.selectByMatch({ matchId: this.matchId }).then((res) => {
      this.groupSelectOptions = res.result;
    });
    TMC.select({ matchId: this.matchId }).then((res) => {
      this.teamRegistrationConfig = res.result;
    });
    RULE.compose({ matchId: this.matchId }).then((res) => {
      this.compose = res.result;
    });
  },
};
</script>
<style scoped>
ul li {
  list-style: none;
}

.el-autocomplete {
  display: block;
}

::deep .el-autocomplete-suggestion {
  width: auto !important;
}
</style>


// WEBPACK FOOTER //
// src/components/PlayerRegister.vue